import React from 'react';
import { connect } from 'react-redux';
import { Paper } from 'material-ui';
import { Row, Col } from 'reactstrap';
import VolverButtomC from './volverButtom';

@connect(store => ({
    general: store.getIn(['general', 'notificacion'])
}))
export default class extends React.Component {
    render(){
      const { general } = this.props;
        return(
            <div className='big_pt-30'>
                <Row className='alignCenter'>
                    <Col md={{ size: 6, offset: 3 }}>
                        <Paper className='container textCenter'>
                            <h3>{general.getIn('notificacion', 'titulo')}</h3>
                            <h4>{general.getIn('notificacion', 'subtitulo')}</h4>
                            <p>{general.getIn('notificacion', 'texto')}</p>
                        </Paper>
                    </Col>
                    <Col md={{ size: 6, offset: 3 }}>
                        <VolverButtomC/>
                    </Col>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/modules/general/components/notificacion.js